import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// // --- Pretty-print each Web Vital: name | value | rating ---
// const ratingLabel = {
//   "good": "✅ Good",
//   "needs-improvement": "⚠️ Needs work",
//   "poor": "❌ Poor",
// };

// const logWebVital = (metric) => {
//   // CLS is a unitless layout-shift score, NOT a time — don't convert it
//   const value =
//     metric.name === "CLS"
//       ? metric.value.toFixed(3)
//       : `${(metric.value / 1000).toFixed(2)}s`;

//   console.log(
//     `${metric.name.padEnd(4)} | ${value.padEnd(7)} | ${
//       ratingLabel[metric.rating] ?? metric.rating
//     }`
//   );
// };

// reportWebVitals(logWebVital);

// // --- Full navigation timing, in seconds, with manual ratings ---
// const rate = (ms, good, poor) =>
//   ms <= good ? "✅ Good" : ms <= poor ? "⚠️ Needs work" : "❌ Poor";

// window.addEventListener("load", () => {
//   setTimeout(() => {
//     const nav = performance.getEntriesByType("navigation")[0];
//     const ttfb = nav.responseStart - nav.requestStart;
//     const dcl  = nav.domContentLoadedEventEnd - nav.startTime;
//     const load = nav.loadEventEnd - nav.startTime;

//     console.table({
//       "TTFB":             { seconds: +(ttfb / 1000).toFixed(2), rating: rate(ttfb, 0.8 * 1000, 1.8 * 1000) },
//       "DOMContentLoaded": { seconds: +(dcl  / 1000).toFixed(2), rating: rate(dcl, 2000, 4000) },
//       "Full page load":   { seconds: +(load / 1000).toFixed(2), rating: rate(load, 2500, 5000) },
//     });
//   }, 0);
// });